import type { EventRecordingStatus } from 'models';
import { Alert, VideoPlayer } from 'ui';

type P = {
  src?: string;
  status: EventRecordingStatus;
};

const VideoRecording = ({ src, status }: P) => (
  <>
    {status === 'recorded' ? <VideoPlayer src={src} /> : null}
    {status === 'processing' ? (
      <Alert description="It will be displayed here once it’s ready." title="The video recording is being processed." />
    ) : null}
  </>
);

export default VideoRecording;
